import { render, staticRenderFns } from "./shopStaffMsgList.vue?vue&type=template&id=49838991&scoped=true"
import script from "./shopStaffMsgList.vue?vue&type=script&lang=js"
export * from "./shopStaffMsgList.vue?vue&type=script&lang=js"
import style0 from "./shopStaffMsgList.vue?vue&type=style&index=0&id=49838991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49838991",
  null
  
)

export default component.exports